
import { Vue, Component, Prop } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import { fireGoogleTag } from '@/utils/google-tag-manager-helpers';
import Cart from '@/components/Cart.vue';
import CalendarViewToggle from '@/components/menu/rotational-menus/CalendarViewToggle.vue';
import WeekNavigator from '@/components/menu/rotational-menus/WeekNavigator.vue';
import MonthNavigator from '@/components/menu/rotational-menus/MonthNavigator.vue';
import LocaleSwitcher from '@/components/navigation/LocaleSwitcher.vue';
import MenuDropdown from '@/components/navigation/MenuDropdown.vue';
import ProfileButton from '@/components/navigation/ProfileButton.vue';
import SearchBar from '@/components/filter/SearchBar.vue';
import GroceryIcon from '../../assets/images/icons/grocery.svg?inline';

const namespace: string = 'search';

@Component<Navbar>({
	components: {
		Cart,
		CalendarViewToggle,
		WeekNavigator,
		MonthNavigator,
		MenuDropdown,
		LocaleSwitcher,
		ProfileButton,
		SearchBar,
		GroceryIcon
	}
})
export default class Navbar extends Vue {
	@Prop({ type: Array, required: true, default: () => [] }) private menus!: Menu[];
	@Prop({ type: Array, required: true, default: () => [] }) private elements!: Menu[] | MenuGroup[];
	@Prop({ type: String, required: true, default: '' }) private elementSelected!: string;
	@Prop({ type: String, required: false, default: '' }) private restaurantDisplayName!: string;
	@Prop({ type: String, required: false, default: '' }) private restaurantImage!: string;
	@Prop({ type: Number, required: true, default: 0 }) private currentElementIndex!: number;
	@Prop({ type: Number, required: false, default: 0 }) private screenWidth!: number;
	@Prop({ type: Boolean, required: false }) private openCartModal!: boolean;
	@Action('updateSearchInput', { namespace }) private updateSearchInput!: (searchText: string) => void;
	@Getter('getSearchInput', { namespace }) private searchInput!: string;
	@Getter('isViewOnly', { namespace: 'cart' }) private isViewOnly!: boolean;
	@Getter('isAnyDietOrAllergen', { namespace: 'filters' }) private isAnyDietOrAllergen!: boolean;
	@Getter('getRestaurant', { namespace: 'restaurant' }) private restaurant!: Restaurant;
	@Getter('isMarketplaceHub', { namespace: 'restaurant' }) private isMarketplaceHub!: boolean;
	@Getter('isK12Location', { namespace: 'restaurant' }) private isK12Location!: boolean;
	@Getter('isK12MonthlyLayoutEnabled', { namespace: 'restaurant' }) private isMonthlyLayoutEnabled!: boolean;
	@Getter('isMonthlyView', { namespace: 'restaurant' }) private isMonthlyView!: boolean;
	@Getter('getLogoRedirectUrl', { namespace: 'restaurant' }) private logoRedirectUrl!: string;
	@Getter('getNutritionalInfoUrl', { namespace: 'restaurant' }) private nutritionalInfoUrl!: string;

	private get imageURL(): string {
		if (process.env.NODE_ENV === 'development') {
			return `${this.restaurantImage}`;
		}
		return `${process.env.VUE_APP_IMAGE_BUCKET}/${this.restaurantImage}`;
	}

	/**
	 * Send event to parent to open the filter side panel
	 *
	 * @return {void}
	 */
	private openFilterSelector(): void {
		this.$emit('open-filter-selector');
	}

	/**
	 * Send event to change the view depending on menu or menu group selected
	 *
	 * @param {number} idx
	 * @param {string} elementName
	 * @return {void}
	 */
	private selectElement(idx: number, elementName: string): void {
		// We empty the search if not already to change menu or menu group
		if(this.searchInput) {
			this.updateSearchInput('');
		}
		this.$emit('select-element', { 'idx': idx, 'elementName': elementName });
		fireGoogleTag({ name: 'menuSelected', detail: elementName });
	}

}
